import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { SegmentoAdjunto } from '../_models/segmento-adjunto';

@Injectable({
  providedIn: 'root'
})
export class SegmentoAdjuntoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/segmentosAdjuntos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as SegmentoAdjunto[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as SegmentoAdjunto[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as SegmentoAdjunto ) );
  }

  obtenerPorIdSegmento( idSegmento: string ) {
    return this.httClient.get( this.rutServicio + '/segmento/' + idSegmento ).pipe( map( res => res as SegmentoAdjunto ) );
  }

  crear( regCrear: SegmentoAdjunto ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as SegmentoAdjunto ) );
  }

  actualizar( regActualizar: SegmentoAdjunto ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as SegmentoAdjunto ) );
  }
}
